import React from 'react';
export type ComparisonRow = {
  left: string;
  right: string;
};
type ComparisonTableProps = {
  headers: [string, string];
  rows: ComparisonRow[];
  /** 'positive' emphasizes the right column in ink; 'cost' emphasizes it in clay. */
  emphasis?: 'positive' | 'cost';
  tone?: 'light' | 'dark';
  caption?: string;
};
export function ComparisonTable({
  headers,
  rows,
  emphasis = 'positive',
  tone = 'light',
  caption
}: ComparisonTableProps) {
  const dark = tone === 'dark';
  const border = dark ? 'border-white/15' : 'border-sage/20';
  const headText = dark ? 'text-white/60' : 'text-ink-muted';
  const leftText = dark ? 'text-ash' : 'text-ink-muted';
  const rightText = dark ? 'text-white' : emphasis === 'cost' ? 'text-clay-dark' : 'text-ink';
  return <div className="overflow-hidden" data-id="element-61" data-mp="1wz5rp3c0sjpu">
      <table className="w-full border-collapse text-left" data-id="element-62" data-mp="1wy4fuwn6jt72">
        {caption && <caption className="sr-only" data-id="element-63" data-mp="21yifbqaptuth">{caption}</caption>}
        <thead data-id="element-64" data-mp="21vw7rqntrfb9">
          <tr className={`border-b ${border}`} data-id="element-65" data-mp="2dxfeheup0e8h">
            {headers.map((header, i) => <th key={header} scope="col" className={`w-1/2 pb-3 pr-5 text-[13px] font-semibold uppercase tracking-kicker ${i === 1 && !dark && emphasis === 'positive' ? 'text-sage-deep' : headText}`} data-id="element-66" data-mp="2dz8jyqtkksew" data-mpi={i}>
                {header}
              </th>)}
          </tr>
        </thead>
        <tbody data-id="element-67" data-mp="2sv7sg2klcukk">
          {rows.map(row => <tr key={row.left} className={`border-b ${border} align-top`} data-id="element-68" data-mp="2sufwurqzuwua">
              <td className={`w-1/2 py-5 pr-5 text-[16px] leading-[1.6] ${leftText}`} data-id="element-69" data-mp="36krq4tzbf1n0">
                {row.left}
              </td>
              <td className={`w-1/2 py-5 text-[17px] leading-[1.6] font-medium ${rightText}`} data-id="element-70" data-mp="3gk0os054l4fp">
                {row.right}
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}